import {
  ACTIVO_TIPOS_EVENTOS,
  CLEAR_ALL,
  GETALL_TIPOS_EVENTOS,
  LOADING_GETALL_TIPOS_EVENTOS,
  PARAMS_TIPOS_EVENTOS,
  SET_LOGOUT,
} from '../../../store/Types';

const initialState = {
  all: [],
  activo: null,
  loadingGetAll: false,
  params: {},
};

export const tiposEventosReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_TIPOS_EVENTOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case ACTIVO_TIPOS_EVENTOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_TIPOS_EVENTOS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_TIPOS_EVENTOS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
